import {Component, effect} from '@angular/core';
import {CustomMessageService} from "library";

@Component({
  selector: 'app-success-message',
  templateUrl: './success-message.component.html'
})
export class SuccessMessageComponent {
  visibleSuccessDialog = false;

  constructor(public customMessageService: CustomMessageService) {
    effect(() => {
      this.visibleSuccessDialog = Object.keys(this.customMessageService.successDialog()).length !== 0;
    });
  }

  onDialogBtn() {
    const dialogData = this.customMessageService.successDialog();
    if (dialogData.callback) {
      dialogData.callback();
    }
    this.customMessageService.clearSuccessDialog();
  }
}
